import {useAddNotification, useTransition} from '@logistics-frontend/blocks'
import type {ServerError} from '@logistics-frontend/core/utils/network'
import type {Optional} from '@logistics-frontend/types'
import {getErrorMessage} from '@logistics-frontend/utils'
import {useCallback} from 'react'

import {fetchOffersCalculate} from 'src/shared/api'
import type {OffersCalculateRequest, OffersCalculateResponse} from 'src/shared/types'

import {toOffers} from '../utils/to-offers'

type Options = {
  onSuccess?: (payload: Optional<OffersCalculateResponse>) => void
  onError?: (error: ServerError) => void
}

export function useFetchOffersCalculate(id?: string) {
  const addNotification = useAddNotification()
  const [{payload, isPending, error}, startTransition] = useTransition<Optional<OffersCalculateResponse>, ServerError>(
    undefined,
    {key: buildKey(id)},
  )

  const fetchOffersCalculateHandler = useCallback(
    (body: OffersCalculateRequest, options?: Options) => {
      startTransition(() => fetchOffersCalculate(body), {
        onCommit: response => {
          options?.onSuccess?.(response)
        },
        onError: error => {
          addNotification(getErrorMessage(error), {
            type: 'error',
          })

          options?.onError?.(error)
        },
      })
    },
    [addNotification],
  )

  return {
    fetchOffersCalculateHandler,
    offers: toOffers(payload),
    isOffersPending: isPending,
    offersError: error,
  }
}

const buildKey = (id?: string) => (id ? `offers-calculate-${id}` : 'offers-calculate')
